import { z } from "zod";
import { getUserSchema } from "../api/get-user.schema";

export const getSubstitutionPlanSchema = z
	.object({
		absenceId: z.string(),
	})
	.merge(getUserSchema);

export type GetSubstitutionPlanSchema = z.infer<typeof getSubstitutionPlanSchema>;
